import React from "react";

import styles from "./Quote.module.scss";
import Quotes from "../Pictos/Quotes";

export default function Quote({sourceName, sourceJob, sourceText, children}) {
    return (
        <blockquote className={styles.Main}>
            <Quotes/>
            { children }

            <div className={styles.Source}>
                <p>
                    <strong>{sourceName}</strong>, {sourceJob}
                </p>
                <p className={'italic'}>{ sourceText }</p>
            </div>
        </blockquote>
    )
}
